/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GroupedBygningerResult } from '../models/grouped-bygninger-result';
import { MatrikelSted } from '../models/matrikel-sted';
import { EjendomSearchResponse } from '../models/ejendom-search-response';
@Injectable({
  providedIn: 'root',
})
class EjendommeService extends __BaseService {
static readonly getBygningerForMatriklerPath = '/ejendomme/getbygninger';
static readonly searchPath = '/ejendomme/search';
static readonly getEjendomsStedByAdresseIdPath = '/ejendomme/adresse';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `EjendommeService.GetBygningerForMatriklerParams` containing the following parameters:
   *
   * - `matrikler`:
   *
   * - `includeEnhedCount`:
   *
   * @return Success
   */
  private getBygningerForMatriklerResponse(params: EjendommeService.GetBygningerForMatriklerParams): __Observable<__StrictHttpResponse<GroupedBygningerResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.matrikler;
    if (params.includeEnhedCount != null) __params = __params.set('includeEnhedCount', params.includeEnhedCount.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/ejendomme/getbygninger`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GroupedBygningerResult>;
      })
    );
  }

  /**
   * @param params The `EjendommeService.GetBygningerForMatriklerParams` containing the following parameters:
   *
   * - `matrikler`:
   *
   * - `includeEnhedCount`:
   *
   * @return Success
   */
  getBygningerForMatrikler(params: EjendommeService.GetBygningerForMatriklerParams): __Observable<GroupedBygningerResult> {
    return this.getBygningerForMatriklerResponse(params).pipe(
      __map(_r => _r.body as GroupedBygningerResult)
    );
  }

  /**
   * @param bfeNummer undefined
   * @return Success
   */
  private searchResponse(bfeNummer: number): __Observable<__StrictHttpResponse<EjendomSearchResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (bfeNummer != null) __params = __params.set('bfeNummer', bfeNummer.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/ejendomme/search`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<EjendomSearchResponse>;
      })
    );
  }

  /**
   * @param bfeNummer undefined
   * @return Success
   */
  search(bfeNummer: number): __Observable<EjendomSearchResponse> {
    return this.searchResponse(bfeNummer).pipe(
      __map(_r => _r.body as EjendomSearchResponse)
    );
  }

  /**
   * @param adresseId undefined
   * @return Success
   */
  private getEjendomsStedByAdresseIdResponse(adresseId: string): __Observable<__StrictHttpResponse<EjendomSearchResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (adresseId != null) __params = __params.set('adresseId', adresseId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/ejendomme/adresse`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<EjendomSearchResponse>;
      })
    );
  }

  /**
   * @param adresseId undefined
   * @return Success
   */
  getEjendomsStedByAdresseId(adresseId: string): __Observable<EjendomSearchResponse> {
    return this.getEjendomsStedByAdresseIdResponse(adresseId).pipe(
      __map(_r => _r.body as EjendomSearchResponse)
    );
  }
}

module EjendommeService {

  /**
   * Parameters for getBygningerForMatrikler
   */
  export interface GetBygningerForMatriklerParams {
    matrikler?: Array<MatrikelSted>;
    includeEnhedCount?: boolean;
  }
}

export { EjendommeService }
